import { render, staticRenderFns } from "./SepaDefault.vue?vue&type=template&id=7a3b7960&"
import script from "./SepaDefault.vue?vue&type=script&lang=js&"
export * from "./SepaDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports